import { addNonEnumerableProperty as r } from "./chunk896.js";
const n = "_sentrySpan";
function S(e, o) {
  o ? r(e, n, o) : delete e[n];
}
function p(e) {
  return e[n];
}
export {
  p as _getSpanForScope,
  S as _setSpanForScope
};
